import { ContentLayout, Header } from "@amzn/awsui-components-react";
import { FC } from "react";
import Layout from "../../../layout/Layout";

const VersionExplorer: FC<any> = () => {
    return (
        <Layout>
            <ContentLayout header={<Header variant="h1">Version Explorer</Header>}>
                <>Version Explorer</>
            </ContentLayout>
        </Layout>
    )
}
export default VersionExplorer;